import { createFormActionPayload, FormActionPayload } from 'modules/forms'
import {
  BasicUserInfo,
  GoalNewPayload,
  GoalPostDto,
  GoalPutDto,
  GoalUpdatePayload,
  GoalWithAccessRightsDto,
} from '../../front-face/models'

export function getUpdatedGoalPayload(
  payload: FormActionPayload<GoalWithAccessRightsDto>,
  user: BasicUserInfo,
  currentPeriodId: number
): FormActionPayload<GoalUpdatePayload> {
  const personInstanceId = user.activePersonInstanceId
  const { goalId, ...goalData } = payload.values

  const bonusPeriodId = payload.values.bonusPeriodId || currentPeriodId

  return createFormActionPayload<GoalUpdatePayload>(
    {
      goalId,
      dto: {
        ...goalData,
        personInstanceId,
        bonusPeriodId,
      } as GoalPutDto,
    },
    payload.complete
  )
}

export function getNewGoalPayload(
  payload: FormActionPayload<GoalWithAccessRightsDto>,
  user: BasicUserInfo,
  currentPeriodId: number
): FormActionPayload<GoalNewPayload> {
  const personId = user.personId
  const { goalId, ...goalData } = payload.values

  const bonusPeriodId = payload.values.bonusPeriodId || currentPeriodId

  return createFormActionPayload<GoalNewPayload>(
    {
      goalId,
      dto: {
        ...goalData,
        personId,
        bonusPeriodId,
      } as GoalPostDto,
    },
    payload.complete
  )
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/goals.ts